// Where a user came from, as shown in the admin. Same semantics as the #activity join ping
// (backend signupPingFields): surface, landing page, referrer host, UTM source/medium/campaign, and whether a
// Google Ads click id is stored. The id itself never reaches the client, only that one exists.

export interface SignupSourceInput {
  signup_surface?: string | null
  signup_source?: {
    referrer_host?: string
    utm_source?: string
    utm_medium?: string
    utm_campaign?: string
    landing?: string
  } | null
  has_google_ads_click?: boolean
}

export interface FormattedSignupSource {
  surface?: string
  /** The public landing page whose link they followed, e.g. "ice-hockey". */
  landing?: string
  from?: string
  utm?: string
  ad: boolean
  isEmpty: boolean
  /** Present parts joined with " · " (surface, landing, from, utm, "ad click"); "" when nothing is known. */
  summary: string
}

export function formatSignupSource(u: SignupSourceInput): FormattedSignupSource {
  const source = u.signup_source
  const surface = u.signup_surface || undefined
  const landing = source?.landing || undefined
  const from = source?.referrer_host || undefined
  const utm =
    [source?.utm_source, source?.utm_medium, source?.utm_campaign]
      .filter((part): part is string => !!part)
      .join("/") || undefined
  const ad = u.has_google_ads_click === true

  const parts = [surface, landing, from, utm]
  if (ad) parts.push("ad click")
  const summary = parts.filter((part): part is string => !!part).join(" · ")

  return { surface, landing, from, utm, ad, isEmpty: summary === "", summary }
}
